import { Dispatch, SetStateAction, useEffect, useState } from 'react';

/**
 * Returns a stateful value, and a function to update it.
 * Resets the state to the initial value when the initial value changes
 */
export function useStateWithReset<T>(initialState: T | (() => T)): [T, Dispatch<SetStateAction<T>>] {
	const resolveInitialState = (param: T | (() => T)) => (typeof param === 'function' ? (param as () => T)() : param);

	const [state, setState] = useState<T>(resolveInitialState(initialState));

	useEffect(
		function updateInitialState() {
			setState(resolveInitialState(initialState));
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[initialState]
	);

	return [state, setState];
}
